<template>
  <div>
    <div class="card" v-show="buscarButton">
      <div class="card__content">
        <form @submit.prevent="submit">
          <div class="row mb-0">
            <div class="col-xs-12" v-show="createButton">
              <button
                class="btn-success btn--bigger"
                @click="currentIndex = -1;crear();"
                type="button"
              >
                <i class="fa fa-external-link"></i>
                <span>Crear</span>
              </button>
            </div>
            <div
              class="col-xs-12"
              :class="{'my-2': (!form.buscarNumero && createButton) && esComprobante, 'mb-3': !createButton && !form.buscarNumero}"
            >
              <div :class="{'form-inline': form.buscarNumero}">
                <label class="mb-0" v-show="esComprobante || buscarNumero">
                  <input type="checkbox" id="buscarNumero" v-model="form.buscarNumero" />
                  <span>Buscar por número</span>
                </label>

                <div class="form-group" v-show="form.buscarNumero">
                  <input-field
                    id="numeroDocumento"
                    placeholder="Número"
                    v-model="form.numero_documento"
                  ></input-field>
                  <button type="submit" class="btn-info">
                    <i class="fa fa-search"></i>
                    <span>Buscar</span>
                  </button>
                </div>

                <div
                  class="form-inline row mb-0 mt-3"
                  v-show="!esComprobante && filterStatus && !form.buscarNumero"
                >
                  <div class="col-xs-12 col-lg-1">
                    <label v-show="!esComprobante && filterStatus && !form.buscarNumero">
                      <p>
                        <strong>Estados:</strong>
                      </p>
                    </label>
                  </div>
                  <div class="col-xs-12 col-lg-10">
                    <label v-show="!esComprobante && !form.buscarNumero">
                      <label v-show="filterStatus">
                        <input @change="submit" v-model="form.status" type="radio" value="A" />
                        <span>
                          {{(tipoDocumento==='EG' || tipoDocumento==='ND' || tipoDocumento=='NC' || tipoDocumento
                          === 'IN' || tipoDocumento ==='CR')?'Emitido':'Activos(as)'}}
                        </span>
                      </label>
                    </label>
                    <label v-show="!esComprobante && tipoDocumento != 'CR'">
                      <label v-show="filterStatus">
                        <input @change="submit" v-model="form.status" type="radio" value="I" />
                        <span>{{(tipoDocumento==='EG' || tipoDocumento==='ND' || tipoDocumento=='NC' || tipoDocumento == 'IN')?'Conciliado':'Inactivo(as)'}}</span>
                      </label>
                    </label>
                    <label
                      v-show="!esComprobante && (tipoDocumento==='EG' || tipoDocumento==='ND' || tipoDocumento=='NC' || tipoDocumento == 'IN' || tipoDocumento ==='CR')"
                    >
                      <label v-show="filterStatus">
                        <input @change="submit" v-model="form.status" type="radio" value="AN" />
                        <span>Anulado</span>
                      </label>
                    </label>
                    <label v-show="!esComprobante">
                      <label v-show="filterStatus">
                        <input @change="submit" v-model="form.status" type="radio" value="T" />
                        <span>Todos(as)</span>
                      </label>
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xs-12" v-show="!form.buscarNumero && esComprobante">
              <div class="form-inline row">
                <div class="col-xs-12 col-lg-1">
                  <label v-show="esComprobante">
                    <p>
                      <strong>Estados:</strong>
                    </p>
                  </label>
                </div>
                <div class="col-xs-12 col-lg-10">
                  <label v-show="esComprobante">
                    <input @change="submit" v-model="form.status" type="radio" value="T" />
                    <span>Todos</span>
                  </label>
                  <label v-show="esComprobante">
                    <input @change="submit" v-model="form.status" type="radio" value="P" />
                    <span>Pendientes de aprobación</span>
                  </label>
                  <label v-show="esComprobante">
                    <input @change="submit" v-model="form.status" type="radio" value="E" />
                    <span>Emitidos</span>
                  </label>
                  <label
                    v-show="(esComprobante) && (form.tipo_comprobante === 'T') && !form.buscarNumero && tipoDocumento!='CO'"
                  >
                    <input @change="submit" v-model="form.status" type="radio" value="AUT" />
                    <span>Autorizadas</span>
                  </label>
                  <label v-show="esComprobante">
                    <input @change="submit" v-model="form.status" type="radio" value="NAT" />
                    <span>No autorizadas</span>
                  </label>
                  <label v-show="esComprobante">
                    <input @change="submit" v-model="form.status" type="radio" value="A" />
                    <span>Anuladas</span>
                  </label>
                </div>
              </div>
            </div>
            <div class="col-xs-12" v-show="!form.buscarNumero && esComprobante">
              <div class="form-inline row">
                <div class="col-xs-12 col-lg-1">
                  <label v-show="esComprobante">
                    <p>
                      <strong>Formato:</strong>
                    </p>
                  </label>
                </div>
                <div class="col-xs-12 col-lg-10">
                  <label v-show="esComprobante">
                    <input @change="submit" v-model="form.formato" type="radio" value="M" />
                    <span>Manual</span>
                  </label>
                  <label v-show="esComprobante">
                    <input @change="submit" v-model="form.formato" type="radio" value="E" />
                    <span>Electrónica</span>
                  </label>
                  <label v-show="esComprobante">
                    <input @change="submit" v-model="form.formato" type="radio" value="T" />
                    <span>Todas</span>
                  </label>
                </div>
              </div>
            </div>
            <div class="col-xs-12" v-show="!form.buscarNumero && (esComprobante || fechas)">
              <div class="form-inline row mb-0">
                <div class="col-xs-12 col-lg-1">
                  <label v-show="esComprobante||fechas">
                    <p>
                      <strong>Fecha:</strong>
                    </p>
                  </label>
                </div>
                <div class="col-xs-12 col-lg-11">
                  <label v-show="esComprobante||fechas">
                    <input @change="submit" v-model="form.tipo_fecha" type="radio" value="H" />
                    <span>Hoy</span>
                  </label>
                  <label v-show="esComprobante||fechas">
                    <input @change="submit" v-model="form.tipo_fecha" type="radio" value="A" />
                    <span>Ayer</span>
                  </label>
                  <label v-show="esComprobante||fechas">
                    <input
                      @change="cambiarPersonalizado"
                      v-model="form.tipo_fecha"
                      type="radio"
                      value="P"
                    />
                    <span>Personalizado</span>
                  </label>
                  <div
                    class="form-field"
                    v-show="((esComprobante && form.tipo_fecha === 'P')||(fechas && form.tipo_fecha ==='P'))"
                  >
                    <div class="datepicker-field datepicker-field--stretch">
                      <VueCtkDateTimePicker
                        id="fecha_desde"
                        v-model="form.fecha_desde"
                        locale="es"
                        no-label
                        only-date
                        auto-close
                        button-now-translation="Ahora"
                        format="YYYY-MM-DD"
                        formatted="YYYY-MM-DD"
                        label="Seleccione una fecha..."
                      />
                      <label>Desde</label>
                      <span
                        v-if="errores.fecha_desde"
                        class="helper-text text-danger"
                        slot="helper"
                      >
                        <strong>{{ errores.fecha_desde[0] }}</strong>
                      </span>
                    </div>
                  </div>
                  <div
                    class="form-field"
                    v-show="((esComprobante && form.tipo_fecha === 'P')||(fechas && form.tipo_fecha ==='P'))"
                  >
                    <div class="datepicker-field datepicker-field--stretch">
                      <VueCtkDateTimePicker
                        id="fecha_hasta"
                        v-model="form.fecha_hasta"
                        locale="es"
                        no-label
                        only-date
                        auto-close
                        button-now-translation="Ahora"
                        format="YYYY-MM-DD"
                        formatted="YYYY-MM-DD"
                        label="Seleccione una fecha..."
                      />
                      <label>Hasta</label>
                      <span
                        v-if="errores.fecha_hasta"
                        class="helper-text text-danger"
                        slot="helper"
                      >
                        <strong>{{ errores.fecha_hasta[0] }}</strong>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xs-12 col-md-3" v-show="verTipoComprobante && !form.buscarNumero">
              <div class="form-field select2">
                <div class="select2-field select2-field--stretch">
                  <v-select
                    id="tipo_comprobante"
                    @onChange="submit"
                    placeholder="Seleccione"
                    v-model="selected_tipo_comprobante"
                    :options="options_tipo_comprobante"
                    label="descripcion"
                  ></v-select>
                  <label for="tipo_comprobante">Tipo de comprobante</label>
                  <span
                    v-if="errores.tipo_comprobante"
                    class="helper-text text-danger"
                    slot="helper"
                  >
                    <strong>{{ errores.tipo_comprobante[0] }}</strong>
                  </span>
                </div>
              </div>
            </div>
            <div class="col-xs-12 col-md-2" v-show="esComprobanteContable">
              <div class="form-field select2">
                <div class="select2-field select2-field--stretch">
                  <v-select v-model="selectedTipo" :options="tipos" label="tipo"></v-select>
                  <label for="tipo">Tipo:</label>
                </div>
              </div>
            </div>
            <div
              class="col-xs-12"
              :class="{'col-md-9': verTipoComprobante, 'col-md-10': esComprobanteContable}"
              v-show="!form.buscarNumero"
            >
              <div class="form-group" v-show="buscarButton">
                <input-field
                  stretch
                  @keyup="keyup"
                  v-model="form.search"
                  id="buscar"
                  placeholder="Realice una consulta..."
                ></input-field>
                <button type="submit" class="btn-info btn--bigger">
                  <i class="fa fa-search"></i>
                  <span>Buscar</span>
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
    <div class="card">
      <div class="card__content">
        <div class="form-inline mb-3">
          <p>Registros por página</p>
          <div class="ktable-select">
            <select @change="submit" id="cantidadRegistros" v-model="form.cantidadRegistros">
              <option :value="10">10</option>
              <option :value="30">30</option>
              <option :value="50">50</option>
              <option :value="100">100</option>
            </select>
          </div>
        </div>
        <div class="table-responsive">
          <table :class="classes" class="table-selectable">
            <thead>
              <tr>
                <th
                  v-show="!column.hidden"
                  v-for="(column, index) in columns"
                  :key="'column' + index"
                >{{ column.display }}</th>
                <th v-show="(editButton || deleteButton || buttons.length > 0)">Acciones</th>
              </tr>
            </thead>
            <tbody>
              <tr
                :class="{
                  'tr--pending' : ((esComprobante && row.id_estado_comprobante === 'PPR' && row.anulado === 'N')),
                  'tr--issued' : (esComprobante && row.id_estado_comprobante === null && row.anulado === 'N'),
                  'tr--canceled' : (esComprobante && row.anulado === 'S') || (!esComprobante && row.estado === 'I'),
                  'tr--authorized' : (esComprobante && row.id_estado_comprobante === 'AUT' && row.anulado === 'N') || (!esComprobante && row.estado === 'A')
                }"
                @dblclick="currentIndex=index;seleccionar(row);"
                v-for="(row, index) in rows"
                :key="'row' + index"
              >
                <td
                  v-show="!column.hidden"
                  v-for="(column, ix) in columns"
                  :key="'cell' + index + ix"
                >
                  <input-field
                    @keyup="emitirInputs(rows)"
                    v-model="row[column.value]"
                    v-if="column.input && column.type !== 'checkbox' && column.type !== 'radio'"
                    :id="'cell' + index + ix"
                    :type="column.type"
                  ></input-field>
                  <label v-else-if="column.input" :for="'cell' + index + ix">
                    <input
                      @change="emitirInputs(rows)"
                      v-model="row[column.value]"
                      :type="column.type"
                      :id="'cell' + index + ix"
                    />
                    <span>&nbsp;</span>
                  </label>
                  <span v-else v-show="!column.input">
                    {{(column.prefijo!=undefined)?'$':''}}{{
                    (column.numeric && row[column.value] !== undefined && lodash.get(row, column.value) !== null)?parseFloat(lodash.get(row, column.value)).toLocaleString(locale):lodash.get(row, column.value) }}
                  </span>
                </td>
                <td
                  class="table-actions"
                  v-show="(editButton || deleteButton || buttons.length > 0)"
                >
                  <button
                    v-if="editButton"
                    @click="currentIndex = index;editar(row);"
                    class="btn-info btn--text"
                    type="button"
                  >
                    <i class="fa fa-edit"></i>
                  </button>
                  <button
                    v-if="deleteButton"
                    @click="currentIndex = index;eliminar(row);"
                    :class="{ 'btn-danger btn--text' : ((row.estado == 'A' && !esNotaDeDebito) || row.estado == 1 || (esNotaDeDebito && row.estado =='E')), 'btn-success btn--text' : (row.estado == 'I' || row.estado == 0) }"
                    type="button"
                  >
                    <i class="fa fa-trash-o"></i>
                  </button>
                  <button
                    @click="$emit(button.event, row)"
                    type="button"
                    v-for="(button, index) in buttons"
                    :key="index"
                    class="btn--text"
                    :class="button.class"
                  >
                    <i class="fa" :class="button.icon"></i>
                    <span v-if="button.text !== ''">{{ button.text }}</span>
                  </button>
                </td>
              </tr>
              <tr v-show="rows.length === 0">
                <td :colspan="columns.length + ((editButton || deleteButton)?1:0)">
                  <strong>No hay datos.</strong>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="ktable-pagination">
          <p
            class="ktable-pagination__button"
            :disabled="form.currentPage == 0 || form.currentPage == 1"
          >
            <a @click="anteriorPagina" href="#">
              <i class="fa fa-chevron-left"></i>
              <span>Anterior</span>
            </a>
          </p>
          <p
            class="ktable-pagination__button"
            :disabled="form.currentPage == totalPages || totalPages == 1"
          >
            <a @click="siguientePagina" href="#">
              <span>Siguiente</span>
              <i class="fa fa-chevron-right"></i>
            </a>
          </p>
          <p>Páginas</p>
          <div class="ktable-select">
            <select @change="submit" v-model="form.currentPage" id="paginaActual">
              <option :value="0" disabled>...</option>
              <option v-for="i in totalPages" :key="'pages' + i" :value="i">{{ i }}</option>
            </select>
          </div>
          <p>de {{ totalPages }}</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    buttons: {
      required: false,
      default: function() {
        return [];
      }
    },
    buscarButton: {
      type: Boolean,
      default: true,
      required: false
    },
    buscarNumero: {
      type: Boolean,
      default: false,
      required: false
    },
    remote: {
      type: Boolean,
      default: true,
      required: false
    },
    esNotaDeDebito: {
      type: Boolean,
      default: false,
      required: false
    },
    esComprobanteContable: {
      type: Boolean,
      default: false,
      required: false
    },
    columns: {
      type: Array,
      default: function() {
        return [];
      },
      required: true
    },
    editButton: {
      type: Boolean,
      default: true
    },
    deleteButton: {
      type: Boolean,
      default: true
    },
    classes: Object,
    path: {
      type: String,
      required: true
    },
    filterStatus: {
      type: Boolean,
      default: true
    },
    esComprobante: {
      type: Boolean,
      default: false
    },
    tipoDocumento: {
      type: String,
      default: null,
      required: false
    },
    keyboard: {
      type: Boolean,
      default: false
    },
    params: {
      type: Object,
      default: function() {
        return {};
      }
    },
    createButton: {
      type: Boolean,
      default: true,
      required: false
    },
    keys: {
      type: Array,
      default: function() {
        return [];
      },
      required: false
    },
    value: {
      required: false,
      default: function() {
        return [];
      }
    },
    fechas: {
      required: false,
      default: false,
      type: Boolean
    },
    codigoPersona: {
      type: String,
      default: function() {
        return null;
      }
    },
    verTipoComprobante: {
      type: false,
      default: false
    },
    tipoFecha: {
      type: String,
      default: "H",
      required: false
    }
  },
  data: function() {
    return {
      locale: locale,
      totalPages: 0,
      rows: [],
      tipos_movimientos_cuentas_contables: [],
      selected_tipo_comprobante: {
        codigo: "T",
        descripcion: "TODOS"
      },
      options_tipo_comprobante: [
        {
          codigo: "T",
          descripcion: "TODOS"
        },
        {
          codigo: "FA",
          descripcion: "FACTURA LOCAL"
        },
        {
          codigo: "FR",
          descripcion: "FACTURA POR REEMBOLSO"
        },
        {
          codigo: "LC",
          descripcion: "LIQUIDACIÓN DE COMPRAS"
        },
        {
          codigo: "NV",
          descripcion: "NOTA DE VENTA"
        },
        {
          codigo: "RI",
          descripcion: "FACTURA RISE"
        }
      ],
      lodash: _,
      form: {
        search: "",
        status: "A",
        cantidadRegistros: 10,
        paginate: true,
        currentPage: 0,
        tipo_fecha: null,
        fecha_desde: null,
        fecha_hasta: null,
        tipo_comprobante: "T",
        formato: "T",
        numero_documento: "",
        buscarNumero: false,
        tipo_comprobante_contable: null
      },
      currentIndex: -1,
      resultados: [],
      selectedTipo: null,
      tipos: [],
      errores: {
        fecha_desde: null,
        fecha_hasta: null,
        tipo_comprobante: null
      }
    };
  },
  methods: {
    cambiarPersonalizado: function() {
      let desde = new Date();
      desde.setDate(desde.getDate() - 7);
      let hasta = new Date();
      this.form.fecha_desde = moment(desde).format("YYYY-MM-DD");
      this.form.fecha_hasta = moment(hasta).format("YYYY-MM-DD");
      this.submit();
    },
    anteriorPagina: function() {
      this.form.currentPage--;
      this.loadRows();
    },
    siguientePagina: function() {
      this.form.currentPage++;
      this.loadRows();
    },
    cargarTipoComprobante: function() {
      let that = this;
      let url = "/api/cargar_tipo_comprobante";
      if (that.esComprobanteContable) {
        axios.get(url).then(function(response) {
          that.tipos = response.data;
          for (let i = 0; i < that.tipos.length; i++) {
            if (that.tipos[i].tipo == "DI") {
              that.selectedTipo = that.tipos[i];
            }
          }
        });
      }
    },
    submit: function() {
      this.limpiarErrores();
      if (this.remote) this.loadRows();
    },
    limpiarErrores: function() {
      this.errores.fecha_desde = null;
      this.errores.fecha_hasta = null;
      this.errores.tipo_comprobante = null;
    },
    keyup: function() {
      if (this.keyboard) this.submit();
    },
    loadRows: function(path) {
      let result = {};
      this.errores = {
        fecha_desde: null,
        fecha_hasta: null
      };
      for (let key in this.form) result[key] = this.form[key];
      for (let key in this.params) result[key] = this.params[key];
      let that = this;
      axios
        .get(
          this.path == null || this.path == undefined
            ? path
            : this.path.replace("undefined", ""),
          {
            params: result
          }
        )
        .then(function(response) {
          let paginator = response.data;
          that.rows = paginator.data;
          that.form.currentPage = paginator.current_page;
          that.totalPages = paginator.last_page;
          if ((path != null || path != undefined) && response.data.length === 0)
            swal("No se han encontrado registros", "Información", "info");
          if (that.form.currentPage > that.totalPages) {
            that.form.currentPage = 1;
            that.loadRows();
          }
          that.actualizarResultados();
        })
        .catch(function(error) {
          let response = error.response;
          if (response !== null && response !== undefined) {
            that.errores = response.data.errors;
          }
        });
    },
    editar: function(row) {
      this.$emit("editar", row);
    },
    eliminar: function(row) {
      this.$emit("eliminar", row);
    },
    seleccionar: function(row) {
      this.$emit("seleccionar", row);
    },
    crear: function() {
      this.$emit("crear");
    },
    actualizarLista: function(row) {
      if (this.currentIndex === -1) {
        this.currentIndex = 0;
        this.rows.splice(0, 0, row);
      } else this.rows.splice(this.currentIndex, 1, row);
    },
    eliminarFila: function(row) {
      this.rows.splice(this.currentIndex, 1, row);
    },
    mostrarResultados: function(resultados) {
      if (resultados.length > 0) {
        for (let i = 0; i < resultados.length; i++)
          this.resultados.push(resultados[i]);
      }
    },
    cargarTiposMovimientoCuentaContable: function() {
      let that = this;
      axios.get("/api/cargar_tipo_comprobante").then(function(response) {
        that.tipos_movimientos_cuentas_contables = response.data;
      });
    },
    emitirInputs: function(value) {
      if (this.keys.length > 0) {
        for (let i = 0; i < this.rows.length; i++) {
          for (let j = 0; j < this.columns.length; j++) {
            if (
              this.columns[j].input &&
              this.rows[i][this.columns[j].value] !== undefined
            ) {
              let index = -1;
              for (let k = 0; k < this.resultados.length; k++) {
                let existe = true;
                for (let l = 0; l < this.keys.length; l++)
                  if (
                    this.resultados[k][this.keys[l]] !==
                    this.rows[i][this.keys[l]]
                  )
                    existe = false;
                if (existe) {
                  index = k;
                  break;
                }
              }
              let obj = JSON.parse(JSON.stringify(this.rows[i]));
              if (index === -1) this.resultados.push(obj);
              else this.resultados.splice(index, 1, obj);
            }
            this.$emit("input", this.resultados);
          }
        }
      }
    },
    actualizarResultados: function() {
      if (this.resultados.length > 0 && this.keys.length > 0) {
        for (let h = 0; h < this.rows.length; h++) {
          for (let i = 0; i < this.resultados.length; i++) {
            let existe = true;
            for (let j = 0; j < this.keys.length; j++) {
              if (
                this.resultados[i][this.keys[j]] !== this.rows[h][this.keys[j]]
              ) {
                existe = false;
                break;
              }
            }
            if (existe) this.rows.splice(h, 1, this.resultados[i]);
          }
        }
      }
    }
  },
  watch: {
    selected_tipo_comprobante: function(value) {
      if (value != null && value != undefined) {
        this.form.tipo_comprobante = value.codigo;
        if (value.codigo != "FA" && value.codigo != "LC")
          this.form.status = "E";
        this.submit();
      } else this.form.tipo_comprobante = null;
    },
    selectedTipo: function(value) {
      if (value != null) {
        this.form.tipo_comprobante_contable = value.tipo;
      } else {
        this.form.tipo_comprobante_contable = null;
      }
    }
  },
  mounted: function() {
    this.cargarTipoComprobante();
    this.form.tipo_fecha = this.tipoFecha;
    if (this.esComprobante) {
      this.form.status = "T";
    }
    this.loadRows();
  }
};
</script>




// WEBPACK FOOTER //
// resources/assets/js/components/element/KTable.vue